import selector from 'styled-selector';



export default selector;
